// extracted by mini-css-extract-plugin
export default {"container":"FileInput_container__CJFep","error":"FileInput_error__EESuY","dz":"FileInput_dz__DX1CT"};